export const isIframed = () => window.parent !== window;
